import { combineEpics } from 'redux-observable';
import loadInitialApp from './loadInitialApp';

export default combineEpics(loadInitialApp);



// WEBPACK FOOTER //
// ./src/Main/services/epics/index.ts